/* eslint-disable max-len */
/* eslint-disable prefer-template */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';
import {jsonToParams} from '../utils/commonUtils';

export const fetchFloatingSummary = ({master, dealer, reservationAdvance, antiquity}) =>
  apiActionCreator({
    'endpoint': `/vehicles/floating-inventory-summary?master=${master || ''}&dealer=${dealer || ''}&reservationAdvance=${reservationAdvance || ''}&antiquity=${antiquity || ''}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOATING_INVENTORY_SUMMARY,
      ActionTypes.FETCHED_FLOATING_INVENTORY_SUMMARY,
      [
        ActionTypes.FETCHED_FLOATING_INVENTORY_SUMMARY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchNotPriorizedVehicles = (dealerId) =>
  apiActionCreator({
    'endpoint': `/vehicles/pending-priorization-vehicules/${dealerId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_NOT_PRIORIZED_VEHICLES,
      ActionTypes.FETCHED_NOT_PRIORIZED_VEHICLES,
      [
        ActionTypes.FETCHED_NOT_PRIORIZED_VEHICLES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchFloatingInventory = ({group, master, sfx, dealer, reservationAdvance, antiquity}, allLines = true) =>
  apiActionCreator({
    'endpoint': `/vehicles/get-floating-inventory-models?group=${group}&all_lines=${allLines || ''}&master=${master || ''}&sfx=${sfx || ''}&dealer=${dealer || ''}&reservationAdvance=${reservationAdvance || ''}&antiquity=${antiquity || ''}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_FLOATING_INVENTORY,
      ActionTypes.FETCHED_FLOATING_INVENTORY,
      [
        ActionTypes.FETCHED_FLOATING_INVENTORY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchAddDaysToDate = (date, days, setDate, name) =>
  apiActionCreator({
    'endpoint': `/calendar-tems/add-days-to-date?date=${date}&days=${days}&area=VEHICULOS`,
    'authenticated': true,
    'types': [
      [ActionTypes.DUMMY_ACTION_FLOATING],
      [
        (response) => {
          setDate(name, response.data);
          return {
            'type': ActionTypes.DUMMY_ACTION_FLOATING,
            'payload': response.data,
          };
        },
      ],
      [ActionTypes.DUMMY_ACTION_FLOATING, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });


export const putFloatingInventory = (order, line, {all, data, updateClient, dealerReservation}, filters, message = '') => {
  return apiActionCreator({
    'endpoint': `/vehicles/floating-inventory-models/${order}/${line}?allData=${all}&updateClient=${updateClient}&dealerId=${dealerReservation}&${jsonToParams(filters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PUT_FLOATING_INVENTORY,
      [
        ActionTypes.FETCHED_PUT_FLOATING_INVENTORY,
        MessageActions.addMessageBoxInfo(message),
      ],
      [
        ActionTypes.FETCHED_PUT_FLOATING_INVENTORY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  });
};

export const deleteFloatingInventory = (order, line, all, dealerReservation, filters, daysDeposit = null) => {
  let message = '';
  if (daysDeposit !== null) {
    message = 'El vehículo se ha actualizado como ' +
    (
      parseInt(daysDeposit || 0, 10) > 80 ?
        'No Disponible debido al tiempo que ha permanecido en depósito.' :
        'Disponible.'
    );
  }
  return apiActionCreator({
    'endpoint': `/vehicles/floating-inventory-models/${order}/${line}?allData=${all}&dealerId=${dealerReservation}&${jsonToParams(filters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.DELETING_FLOATING_INVENTORY,
      [
        ActionTypes.DELETED_FLOATING_INVENTORY,
        MessageActions.addMessageBoxInfo('Se ha actualizado exitosamente. ' + message),
      ],
      [
        ActionTypes.DELETED_FLOATING_INVENTORY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'DELETE',
  });
};

export const fetchAdviserList = (dealer) =>
  apiActionCreator({
    'endpoint': `/vehicles/adviser-list?dealer=${dealer}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ADVISERS_LIST,
      ActionTypes.FETCHED_ADVISERS_LIST,
      [
        ActionTypes.FETCHED_ADVISERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const uploadFileID = (order, line, file) =>
  apiActionCreator({
    'endpoint': `/vehicles/adviser-list?order=${order}&line=${line}&document=idClient`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ADVISERS_LIST,
      ActionTypes.FETCHED_ADVISERS_LIST,
      [
        ActionTypes.FETCHED_ADVISERS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchExonerationPercentajes = () =>
  apiActionCreator({
    'endpoint': '/vehicles/exemption',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_EX_PERCENTAJES_FL_INVENTORY,
      ActionTypes.FETCHED_EX_PERCENTAJES_FL_INVENTORY,
      [
        ActionTypes.FETCHED_EX_PERCENTAJES_FL_INVENTORY_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchFloatClientInfo = (clientId, dealerReservation) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/client-check/${clientId}/${dealerReservation}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_FLOAT_CLIENT_INFO,
        [
          ActionTypes.FETCHED_FLOAT_CLIENT_INFO,
          MessageActions.addMessageBoxInfo('El cliente ya existe. Se ha actualizado la información.'),
        ],
        [
          ActionTypes.FETCHED_FLOAT_CLIENT_INFO_FAILED,
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const setCurrentFloatingLine = (floatingData) => ({
  'type': ActionTypes.SET_CURRENT_FLOATING_LINE,
  'payload': floatingData,
});

export const updateCurrentFloatingLine = (key, value) => ({
  'type': ActionTypes.UPDATE_CURRENT_FLOATING_LINE,
  'payload': {key, value},
});

export const updateCurrentFloatingLineError = (key, value) => ({
  'type': ActionTypes.UPDATE_CURRENT_FLOATING_LINE_ERROR,
  'payload': {key, value},
});

export const cleanCurrentLineFloating = () => ({
  'type': ActionTypes.CLEAN_CURRENT_LINE_DATA_FLOATING,
  'payload': null,
});

export const setBlockFloatingTable = (value) => ({
  'type': ActionTypes.SET_BLOCK_FLOATING_TABLE,
  'payload': value,
});

export const setCurrentLineErrorFloating = (value) => ({
  'type': ActionTypes.SET_CURRENT_LINE_ERROR_FLOATING,
  'payload': value,
});

export const setCurrentFloatingOrderClient = (value) => ({
  'type': ActionTypes.SET_CURRENT_FLOATING_ORDER_CLIENT,
  'payload': value,
});

export const setCurrentFlUserGroup = (group) => ({
  'type': ActionTypes.SET_CURRENT_FLOATING_USER_GROUP,
  'payload': group,
});

export const setIsNotpriorizedModalOpen = (value) => ({
  'type': ActionTypes.SET_IS_NOT_PRIORIZED_MODAL_OPEN,
  'payload': value,
});

export const setDataWasShown = (value) => ({
  'type': ActionTypes.SET_FLOATING_DATA_WAS_SHOWN,
  'payload': value,
});
